import script from "./SplitModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplitModal.vue?vue&type=script&setup=true&lang=ts"

import "./SplitModal.vue?vue&type=style&index=0&id=fbe5809a&lang=scss"

const __exports__ = script;

export default __exports__